import { render, staticRenderFns } from "./QuotesFilters.vue?vue&type=template&id=48e2fabd"
import script from "./QuotesFilters.vue?vue&type=script&lang=js"
export * from "./QuotesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports